<template>
  <div class="m-grid__item m-grid__item--fluid m-wrapper">
    <div class="m-subheader ">
      <div class="d-flex align-items-center">
        <div class="mr-auto">
          <h3 class="m-subheader__title ">

          </h3>
        </div>
      </div>
    </div>
    <div class="m-content">
      <div class="about-margin m--padding-30 text-center">
        <div class="panel-title">
          <span class="">
            <img class="navbar-brand-logo" src="../../../static/img/logo.png" title="zizi logo">
          </span>
        </div>
        <div class="m-portlet__body">
          <h3>Under Development</h3>
          <p>We are working hard on availing this module soon.</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "comingsoon"
};
</script>






// WEBPACK FOOTER //
// src/components/pages/ComingSoon.vue